<script>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  props: {
    user: Object
  },

  setup (props) {
    const router = useRouter()

    onMounted(() => {
      if (props.user.is_parent) {
        router.replace('/journal/parent')
      } else if (props.user.is_employee) {
        router.replace('/journal/employee')
      } else if (props.user.is_kindergarten_director) {
        router.replace('/journal/kindergarten-director')
      }
    })
  },

  render () {
    return null
  }
}
</script>
